
const Methods = 
{

    methods: 
    {
        refreshHeaders()
        {
            setTimeout(() => {
                this.$refs.main_table.refresh_headers(false)
            }, 200);
        },

        returnedRoomsToParent(withoutChecking = false)
        {
            if(this.use_parent)
            {
                if(this.parent_rooms.length)
                {
                    let select_all = this.$refs.main_table.select_all
                    
                    let room_ids =  withoutChecking ? this.parent_rooms : this.parent_rooms.filter(item => item.checked)

                    return {
                        select_all,
                        room_ids,
                        params: this.$refs.main_table.params,
                    }
                }
            }
            else
            {
                if(this.rooms.length)
                {
                    let select_all = this.$refs.main_table.select_all
                    
                    let room_ids =  withoutChecking ? this.rooms : this.rooms.filter(item => item.checked)

                    return {
                        select_all,
                        room_ids,
                        params: this.$refs.main_table.params,
                    }
                }
            }
            return null
        },

        selectAllBoxes()
        {
            if(this.rooms.length)
            {
                this.rooms.map((item) => {
                    item.checked = this.selectAll
                })
            }
        },

        fillData(data)
        {
            let array_options = {}
            
            this.form_format.forEach(item => {
                if(item.type == 'select')
                {
                    
                    if(data[item.model_name])
                    {
                        array_options[item.model_name] = data[item.model_name]
                    }
                    else if(this.array_options[item.model_name] && this.array_options[item.model_name].length)
                    {
                        array_options[item.model_name] = this.array_options[item.model_name]
                    }
                }
            })

            this.array_options = array_options
        },
        resetList()
        {
            this.$refs.main_table.params['page'] = 1;
            this.fetchMainList(this.$refs.main_table.params)
        }

    },
}

export default Methods